import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Permissions_objects extends PureComponent {
  render() {
    return (
      <div className="row" id="permissions_objects">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Object Level Permissions</h2>
              <p>
                Object level permissions allow the administrator to set
                permissions for a user or group to access an object type. Object
                types are defined in your installed modules. It is possible to
                have permissions saved against users or groups which is no
                longer in your installed modules. When this happens they will
                appear in the permission settings section of the Nexoid
                application as an unknown permission.{" "}
              </p>
              <p>
                Object level permissions include ability to create, read, edit,
                delete, view the audit history of a record and upload and
                download files attached to a record.
              </p>
              <p>
                Object level record permissions still require a record level
                permission setting. The two Basic options are “star”{" "}
                <strong>(*)</strong> which gives you access to all of that type
                of object regardless of the objects record level permissions
                heading and “question mark” <strong>(?)</strong> Which gives you
                access to all of that type of object which does not have a
                record level permission setting.
              </p>
              <p>
                The format of record level permissions is [data object]
                <strong>|</strong>[record level permission]<strong>|</strong>
                [permission]
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Object Level Permission List</h2>
            </section>

            <section>
              <h3>Permission Types</h3>
              <p>These are the types of permissions which can be applied.</p>
              <p>Permission:</p>
              <div className="darkCode">
                <span className="jsonY">Create</span> <br />
                <span className="jsonY">Read</span> <br />
                <span className="jsonY">Edit</span> <br />
                <span className="jsonY">Delete</span> <br />
                <span className="jsonY">Audit</span> <br />
                <span className="jsonY">FileDownload</span> <br />
                <span className="jsonY">FileUpload</span> <br />
              </div>
            </section>

            <section>
              <h3>Example 1</h3>
              <p>
                In this example a user can read all <strong>"change"</strong>{" "}
                object records and can read, edit and create{" "}
                <strong>"incident"</strong> records.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <div className="darkCode">
                  <div>[</div>
                  <div className="i1">
                    <span className="jsonY">"change|*|Read"</span>,
                  </div>
                  <div className="i1">
                    <span className="jsonY">"incident|*|Create"</span>,
                  </div>
                  <div className="i1">
                    <span className="jsonY">"incident|*|Read"</span>,
                  </div>
                  <div className="i1">
                    <span className="jsonY">"incident|*|Edit"</span>
                  </div>
                  <div>]</div>
                </div>
              </div>
            </section>

            <section>
              <h3>Example 2</h3>
              <p>
                In this example a user has the ability edit a{" "}
                <strong>"task"</strong> record and assign it to another user.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <div className="darkCode">
                  <div>[</div>
                  <div className="i1">
                    <span className="jsonY">"USERSREAD"</span>,
                  </div>
                  <div className="i1">
                    <span className="jsonY">"task|*|Read"</span>,
                  </div>
                  <div className="i1">
                    <span className="jsonY">"task|*|Edit"</span>
                  </div>
                  <div>]</div>
                </div>
              </div>
            </section>

            <section>
              <h3>Example 3</h3>
              <p>
                In this example the user has the ability to open a{" "}
                <strong>"contact"</strong> record’s audit history and download
                any files connected to that record.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <div className="darkCode">
                  <div>[</div>
                  <div className="i1">
                    <span className="jsonY">"contact|*|Read"</span>,
                  </div>
                  <div className="i1">
                    <span className="jsonY">"contact|*|Audit"</span>,
                  </div>
                  <div className="i1">
                    <span className="jsonY">"contact|*|FileDownload"</span>
                  </div>
                  <div>]</div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Permissions_objects;



// WEBPACK FOOTER //
// ./src/components/knowlege/security/Permissions_objects.js